import { render, staticRenderFns } from "./NavigationTop.vue?vue&type=template&id=0cff7a81&scoped=true&"
import script from "./NavigationTop.vue?vue&type=script&lang=js&"
export * from "./NavigationTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff7a81",
  null
  
)

export default component.exports